var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useState } from 'react';
import { postBotMessage, Triggers } from '../../../../apis/postBotMessage';
import { Types } from '../../../states/actions';
import Cookie from 'js-cookie';
import { analytics, ChatEventName, EventCategory } from '../../../../analytics';
import { useError } from '../../../../providers/ErrorProvider/context';
// Trigger API to send a bot message.
export function useSendBotMessage(chatState, dispatch, sessionToken, apiBaseUrl) {
    var _this = this;
    var hasCustomerAddedNewMessage = chatState.hasCustomerAddedNewMessage, _a = chatState.channelId, channelId = _a === void 0 ? '' : _a;
    var _b = useState(true), shouldSendMessage = _b[0], setShouldSendMessage = _b[1];
    var onException = useError().onException;
    useEffect(function () {
        // send bot message when team member is not assigned yet
        var botMessageWhenCustomerAwaitingResponse = function () { return __awaiter(_this, void 0, void 0, function () {
            var userSession, in8Hours, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!hasCustomerAddedNewMessage) return [3 /*break*/, 5];
                        userSession = Cookie.get('user_in_session');
                        if (!!userSession) return [3 /*break*/, 5];
                        in8Hours = new Date(new Date().getTime() + 8 * 60 * 60 * 1000);
                        Cookie.set('user_in_session', 'Yes', { expires: in8Hours }); // expires 8 hours
                        dispatch({ type: Types.START_BOT_TYPING });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, postBotMessage(channelId, sessionToken, apiBaseUrl, Triggers.CustomerAwaitingTeamMemberResponse)];
                    case 2:
                        _a.sent();
                        analytics({
                            event_name: ChatEventName.NO_RESPONSE_MESSAGE_SENT,
                            category: EventCategory.CHAT,
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        onException(new Error("@lendi/chat: ".concat(error_1.message, " with: ").concat(Triggers.CustomerAwaitingTeamMemberResponse)));
                        return [3 /*break*/, 4];
                    case 4:
                        dispatch({ type: Types.STOP_BOT_TYPING });
                        setShouldSendMessage(false);
                        dispatch({ type: Types.RESET_HAS_CUSTOMER_ADDED_NEW_MESSAGE });
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        if (shouldSendMessage) {
            botMessageWhenCustomerAwaitingResponse();
        }
    }, [hasCustomerAddedNewMessage]);
}
//# sourceMappingURL=index.js.map